const HAPPY_PATH_SAMPLE_RATE = 0.1;
const SLOW_THRESHOLD_MS = 1000;

// 100% of errors (incl. status=0 network failures) + slow (>=1s); 10% happy-path to cap ingest.
export function shouldSampleApiRequest(status: number, durationMs: number): boolean {
  if (status === 0) return true;
  if (status >= 400) return true;
  if (durationMs >= SLOW_THRESHOLD_MS) return true;
  return Math.random() < HAPPY_PATH_SAMPLE_RATE;
}
